import MainPage from "../../components/Main/MainPage";

function LandingMain() {
  return <MainPage></MainPage>;
}

export default LandingMain;
